<template>
  <div>
    <a-modal
      :class="{ 'dark-theme-modal': darkTheme }"
      width="700px"
      title="Ajouter un commentaire global"
      v-model="modalVisible">
      <template slot="footer">
        <a-tooltip placement="top" >
          <template slot="title">
            <span>Supprimer le commentaire</span>
          </template>
          <a-button type="danger" @click="handleRemove" :ghost="darkTheme ? true : null">Supprimer</a-button>
        </a-tooltip>
        <a-button key="back" @click="handleCancel" :ghost="darkTheme ? true : null">Annuler</a-button>
        <a-button key="submit" type="primary" @click="handleSubmit" :ghost="darkTheme ? true : null">Valider</a-button>
      </template>
      <a-row type="flex">
        <a-col :span="24">
          <a-form :form="form">
            <a-form-item label="Remarque :">
              <a-textarea
                autoFocus
                :autosize="{ minRows: 3, maxRows: 10 }"
                @change="e => handleChangeCommentField(e.target.value)"
                v-decorator="[
                'remarque',
                {
                  rules: [{ required: true, message: 'Veuillez saisir un commentaire ou cliquer sur Annuler' }],
                  initialValue: selectedWork.remarque
                }]"
                placeholder="Rentrez votre commentaire ici" />
            </a-form-item>
          </a-form>
        </a-col>
      </a-row>
      <a-row type="flex">
        <a-col :span="24">
          <div class="comment-container">
            <template v-for="comment in commentsData">
              <CommentSuggestion class="comment-spacing" :key="comment.numero" @clicked="handleCommentSuggestionClick" :text="comment.remarque" />
            </template>
          </div>
        </a-col>
      </a-row>
      <a-row type="flex">
        <a-col :span="24">
          <p class="note-comment no-margin">Note : le commentaire n'est pas daté. En outre, il est par défaut anonyme. Il convient donc d'ajouter sa signature au commentaire.</p>
        </a-col>
      </a-row>
    </a-modal>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import moment from 'moment'
import CommentSuggestion from '../detail/CommentSuggestion'
import CommentService from '../../services/comment_service'

export default {
  name: 'CommentWorkModal',
  components: {
    CommentSuggestion
  },
  data () {
    return {
      form: this.$form.createForm(this),
      commentsData: undefined,
      defautComment: undefined
    }
  },
  methods: {
    moment,
    ...mapActions({
      'toggleCommentWorkModalVisible': 'modal/toggleCommentWorkModalVisible',
      'setSelectedWork': 'work/setSelectedWork'
    }),
    handleChangeCommentField (comment) {
      const newData = this.selectedWork
      Object.assign(newData, { remarque: comment })
      this.setSelectedWork(newData)
    },
    handleCommentSuggestionClick (suggestion) {
      // Récupération de la position du curseur
      let element = document.getElementById('remarque')
      let cursorPosition = element.selectionStart
      let output = element.value
      if (output) {
        output = [output.slice(0, cursorPosition), suggestion, output.slice(cursorPosition)].join('') + ' '
      } else {
        output = suggestion + ' '
      }
      const newData = this.selectedWork
      Object.assign(newData, { remarque: output })
      this.setSelectedWork(newData)
      this.form.setFieldsValue({
        remarque: output
      })
      element.focus()
    },
    handleRemove () {
      this.$confirm({
        title: 'Êtes-vous sûr ?',
        okText: 'Oui',
        okType: 'danger',
        cancelText: 'Non',
        onOk: () => {
          console.log('OK')
          this.defautComment = ''
          this.form.setFieldsValue({
            remarque: ''
          })
          this.modalVisible = 'default'
          this.form.resetFields()
          this.$emit('removed')
        }
      })
    },
    handleCancel () {
      this.form.setFieldsValue({
        remarque: this.defautComment
      })
      const newData = this.selectedWork
      Object.assign(newData, { remarque: this.defautComment })
      this.setSelectedWork(newData)
      this.modalVisible = 'default'
    },
    handleSubmit (e) {
      this.form.validateFields((err, values) => {
        if (err || !values.remarque.match(/[a-z]/i)) {
          return
        }
        this.defautComment = values.remarque
        this.modalVisible = 'default'
        this.form.resetFields()
        this.$emit('clicked', values)
      })
    }
  },
  computed: {
    // v-model va automatiquement essayer de set printModalVisible lors de la fermeture de la modale. On crée donc
    // une computed property en lui indiquant quelle state il doit modifier suivant le type de la modale
    modalVisible: {
      get () {
        return this.commentWorkModalVisible
      },
      set (value) {
        this.toggleCommentWorkModalVisible()
      }
    },
    ...mapState({
      darkTheme: state => state.darkTheme,
      commentWorkModalVisible: state => state.modal.commentWorkModalVisible,
      selectedWork: state => state.work.selectedWork,
      user: state => state.auth.user
    })
  },
  async created () {
    this.defautComment = this.selectedWork.remarque
    // Si user authentifié est enseignant, on fetch les remarques préformattées
    if (this.user.permissionLevel === 1) {
      const response = await CommentService.getComments()
      if (response) {
        const data = response.data.data
        this.commentsData = data.filter(x => x.positif === 1)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.note-comment{
  margin-top: 20px;
  text-align: justify;
}
.comment-container{
  height: 100px;
  overflow-x: scroll;
  white-space: nowrap;
}
.comment-suggestion{
  display: inline-block;
}
.comment-spacing{
  margin-right: 10px;
}
</style>
